import { createAction, props } from '@ngrx/store';

import { BAC_ACTION_PREFIX } from '../constants';

export const setShouldExtendTimeToLiveAction = createAction(
  `${BAC_ACTION_PREFIX} Extend flowId TTL`,
  props<{ extendTimeToLive: boolean }>()
);
